// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_box_box-1Pmz5zr","disabled":"qempo_box_disabled-fP8PZRs","clickable":"qempo_box_clickable-1LxFTsX","boxTitle":"qempo_box_boxTitle-3i4kp1N","noSpace":"qempo_box_noSpace-3Xlgvkm","smallSpace":"qempo_box_smallSpace-4a5FGOt","subtitle":"qempo_box_subtitle-yhesyhx"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/box.scss
// module id = 36
// module chunks = 0